import React from "react";

const Contact = () => {
  return <div>contactus page</div>;
};

export default Contact;
